import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { hostName } from "../../../../App";
import { ClapSpinner } from "react-spinners-kit";
import { useTranslation } from "react-i18next";
import Tippy from "@tippyjs/react";
import CompletePledgeModal from "../../../../components/sites/home/pledges/CompletePledgeModal";
import ECheckModal from "../../../../components/sites/home/pledges/ECheckModal";

const FulfillPledge = ({ setLoggedInUserData, orgObj }) => {
  // use t function where ever hard coded text is used
  const { t } = useTranslation();

  // code
  const { code } = useParams();

  // by code states
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  // by code api
  useEffect(() => {
    axios
      .get(`${hostName}api/v1/pledge/details?code=${code}`, {
        headers: {
          "X-Local-Access-Token":
            "zrPIG1Q90I0cfPhmBZuH1hQErA1mUvQG7mE4jk3ta8lqBJw1L15TGvqJD5MMxwAO",
        },
      })
      .then((res) => {
        if (res.data?.data) {
          setData(res.data.data);
        } else {
          setError("No data field found in response");
        }
      })
      .catch((err) => {
        let errorMessage = "An unexpected error occurred. Please try again.";

        if (err.response) {
          // Server responded with a status code outside of the 2xx range
          errorMessage = err.response.data?.message || "Server error occurred.";
        } else if (err.request) {
          // Request was made but no response was received
          errorMessage =
            "No response from server. Please check your connection.";
        } else {
          // Something else happened while setting up the request
          errorMessage = err.message;
        }

        setError(errorMessage);
      })
      .finally(() => setLoading(false));
  }, [code]);

  // selected payment method
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({
    type: "gateway",
    nodeTag: "",
  });

  useEffect(() => {
    if (data?.paymentMethods?.length) {
      const gatewayMethod = data.paymentMethods.find(
        (method) => method.type === "gateway"
      );

      if (gatewayMethod) {
        setSelectedPaymentMethod(gatewayMethod);
      } else {
        setSelectedPaymentMethod(data.paymentMethods[0]);
      }
    }
  }, [data?.paymentMethods]);

  // donation modal
  const [donationModal, setDonationModal] = useState(false);

  // eCheck modal
  const [eCheckModal, setECheckModal] = useState(false);

  // pay now
  const handlePayNow = () => {
    if (selectedPaymentMethod.type === "gateway") {
      setDonationModal(true);
    } else if (selectedPaymentMethod.type === "eCheck") {
      setECheckModal(true);
    } else {
      alert("Coming Soon!");
    }
  };

  return (
    <>
      {donationModal && (
        <CompletePledgeModal
          data={data}
          setDonationModal={setDonationModal}
          orgObj={orgObj}
          setLoggedInUserData={setLoggedInUserData}
          selectedPaymentMethod={selectedPaymentMethod}
        />
      )}

      {eCheckModal && (
        <ECheckModal
          data={data}
          setECheckModal={setECheckModal}
          orgObj={orgObj}
          selectedPaymentMethod={selectedPaymentMethod}
        />
      )}

      {loading ? (
        <main className="info-content-div" style={{ height: "100%" }}>
          <ClapSpinner size={30} color="#007c16" loading={loading} />
        </main>
      ) : error ? (
        <main className="info-content-div" style={{ height: "100%" }}>
          <div className="error-msg" style={{ marginTop: 0 }}>
            {error}
          </div>
        </main>
      ) : data ? (
        <>
          <div className="pledge-payment-container">
            {/* Fulfill Pledge Section */}
            <div className="fulfill-pledge-container">
              {/* Banner Section */}
              <div className="fulfill-banner">
                <img
                  src={orgObj.logo}
                  alt="Campaign Banner"
                  className="fulfill-banner-img"
                />
                <div className="campaign-info">
                  <h3>{data.headerName}</h3>
                  <p className="organization">{data.organizationName}</p>
                </div>
              </div>

              {/* Pledge Details */}
              <div className="fulfill-pledge-details">
                <div className="pledge-row">
                  <strong>{t("pledge.pledge_tag")}:</strong>{" "}
                  <span>{data.pledgeTag}</span>
                </div>
                <div className="pledge-row">
                  <strong>{t("pledge.status")}:</strong>
                  <Tippy content={data.pledgeStatusText}>
                    <span style={{ cursor: "pointer" }}>
                      <img
                        src={data.pledgeStatusImage}
                        alt="Pledge Status"
                        className="status-icon"
                      />
                    </span>
                  </Tippy>
                </div>
                <div className="pledge-row">
                  <strong>{t("pledge.amount_pledged")}:</strong>
                  <span>
                    {data.currencySymbol}
                    {data.pledgedAmount}
                  </span>
                </div>
                <div className="pledge-row">
                  <strong>{t("pledge.remaining_amount")}:</strong>
                  <span>
                    {data.currencySymbol}
                    {data.pledgeRemainingAmount}
                  </span>
                </div>
                <div className="pledge-row">
                  <strong>{t("pledge.frequency")}:</strong>{" "}
                  <span>{data.pledgeFrequencyText}</span>
                </div>
                {data.pledgeFrequencyText !== "Deferred" && (
                  <div className="pledge-row">
                    <strong>{t("pledge.installments")}:</strong>{" "}
                    <span>{data.pledgeInstallments}</span>
                  </div>
                )}
                <div className="pledge-row">
                  <strong>{t("pledge.start_date")}:</strong>{" "}
                  <span>{data.pledgeStartDate}</span>
                </div>
                <div className="pledge-row">
                  <strong>{t("pledge.due_date")}:</strong>{" "}
                  <span>{data.pledgeDueDate}</span>
                </div>
              </div>
            </div>

            {/* Payment Section */}
            <div className="payment-container">
              {parseFloat(data?.pledgeRemainingAmount) > 0 ? (
                <>
                  <h3>{t("pledge.payment_methods")}</h3>
                  <div className="pledge-payment-options-div">
                    {data?.paymentMethods?.length > 0 ? (
                      <>
                        {data.paymentMethods.map((method, index) => (
                          <label
                            key={method.nodeTag}
                            className="payment-option"
                          >
                            <input
                              type="radio"
                              name="paymentMethod"
                              value={method.type}
                              className="payment-radio"
                              checked={
                                selectedPaymentMethod.type === method.type
                              }
                              onChange={() => setSelectedPaymentMethod(method)}
                            />
                            {method.type === "gateway"
                              ? t("pledge.credit_card")
                              : `${method.type} ${t("pledge.pre_authorized_debit")}`}
                          </label>
                        ))}

                        <button
                          type="button"
                          className="pay-button"
                          onClick={handlePayNow}
                        >
                          {t("pledge.setup_payment")}
                        </button>
                      </>
                    ) : (
                      <div className="error-msg" style={{ width: "100%" }}>
                        {t("pledge.not_found")}
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div className="pledge-fulfilled-notification">
                  <div className="fulfilled-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="check-icon"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <h3 className="fulfilled-message">
                      {t("pledge.fulfilled")}
                    </h3>
                    <p className="fulfilled-subtext">
                      {t("pledge.no_remaining_amount")}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <main className="info-content-div" style={{ height: "100%" }}>
          <div className="error-msg" style={{ marginTop: 0 }}>
            {t("pledge.not_found")}
          </div>
        </main>
      )}
    </>
  );
};

export default FulfillPledge;
